jQuery(document).ready(function(){
    jQuery('.wp-block-garden-slider.is-style-same-height .wp-block-group.is-style-rounded-corner-yellow-box-hover').each(function(){
        let currentGroup = jQuery(this);
        if(currentGroup.find('a[href]').length) currentGroup.click(function(){
            window.location.href = currentGroup.find('a[href]').attr('href');
        })
    })
})